<template>
  <div class="flex items-center justify-center w-full h-full dark:invert">
    <Vue3Lottie
      ref="lottieAnimation"
      :animationData="loaderJSON"
      :height="height"
      :width="width"
      :loop="true"
      :autoPlay="true"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Vue3Lottie } from 'vue3-lottie';
import loaderJSON from '@/Lotti/loader.json';

const props = defineProps({
  height: {
    type: Number,
    default: 40,
  },
  width: {
    type: Number,
    default: 40,
  },
});

const lottieAnimation = ref(null);
</script>

<style scoped>
/* Lottie animation styling */
</style>
